import React, { useEffect } from 'react'
import { hot } from 'react-hot-loader/root'
import AOS from 'aos'
import { Routes } from './Config/routes'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import './App.css'
import 'antd/dist/antd.min.css'
import { registerServiceWorker } from './ServiceWorker'
import { ConfigProvider, Empty } from 'antd'
import enUS from 'antd/es/locale/en_US'
import itIT from 'antd/es/locale/it_IT'
import { useSelector } from 'react-redux'
import { translations } from './utils/constants'

AOS.init()

const theme = createTheme({
  palette: {
    primary: {
      main: '#007aff',
      secondMain: '#1890ff'
    }
  }
})

const App = () => {
  const language = useSelector((state) => state.language?.language || 'en')

  useEffect(() => {
    registerServiceWorker()
  }, []);

  return (
    <div>
      <ConfigProvider locale={language === 'it' ? itIT : enUS} renderEmpty={() => <Empty description={translations[language]?.noData} />}>
        <ThemeProvider theme={theme}>
          <Routes />
        </ThemeProvider>
      </ConfigProvider>
    </div>
  )
}

export default hot(App)
